<template>
    <b-container fluid >

        <b-row class="contacto-principal" align-h="center">
        <b-col cols="12" lg="4">
        </b-col>
        <b-col cols="11" class="col-center mx-auto titulo-reclamo" lg="4">
            <p class="claim-principal-content" style="width: 100%">Libro de Reclamaciones</p>
            <p class="claim-principal-content" style="width: 100%; font-size: 20px;">Hoja de Reclamación N° 21</p>
            <p class="claim-principal-content" style="width: 100%; font-size: 20px;">{{date_claim}}</p>
            <p class="claim-principal-content" style="width: 100%; font-size: 20px;">GOX INTERNATIONAL S.A.C</p>
            <p class="claim-principal-content" style="width: 100%; font-size: 15px;">Av. Circunvalación del Golf Los Incas 510-530, Torre B #102, Surco.</p>
            <p class="claim-principal-content" style="width: 100%; font-size: 20px;">RUC: 20609615266</p>
        </b-col>
        <b-col cols="12" lg="4">
        </b-col>
        <b-col cols="12" lg="4">
        </b-col>
        <b-col cols="12" lg="5" class="col-center">
            <b-row>
                <b-col cols="12" style="padding: 0">
                    <b-col cols="11" class="contacto-principal-content-form mx-auto">
                        <!-- <formulario :content="formulario"/> -->
                        <Form-claim :content="formulario"></Form-claim>
                    </b-col>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="12" lg="3">
        </b-col>
    </b-row>
        
       
        
    </b-container>
</template>
<script>

    import FormClaim from '@/components/forms/Form-claim.vue';

    export default {
        name: 'Claim',
        components: {
            FormClaim
        },
        props: {
            content: Object
        },
        mounted() {
                    const today = new Date();
                    const date = today.getDate()+'-'+(today.getMonth()+1)+'-'+today.getFullYear();
                    const time = today.getHours() + ":" + today.getMinutes();
                    const dateTime = date +' '+ time;
                    this.date_claim = dateTime;
        },
        data: () => ({

            date_claim: '',

            section_claim : {
                content: 'Completa este formulario para recibir asesoría a la medida de tu negocio.'
            },
            formulario: {
                class_color: 'formulario-black',
                text_boton: 'Enviar',
                boton_img: false
            }
        }),
        methods: {}
    }
</script>
<style scoped>
.contacto-principal {
    padding-top: 2rem;
    
  }
.claim-principal-content{
    font-style: normal;
    font-weight: 500;
    font-size: 25px;
    line-height: 34px;
    color: #000000;
    padding-top: 0rem;
    padding-bottom: 0rem !important;
    width: 30rem;
    text-align: center;
  }



@media (max-width: 600px) {
  .claim-principal-content{
    font-style: normal;
    font-weight: 500;
    font-size: 25px;
    line-height: 34px;
    color: #000000;
    padding-top: 0rem;
    padding-bottom: 0rem !important;
    width: 30rem;
    text-align: center;
  }

  .contacto-principal {
    padding-top: 1rem;
  }
}
</style>